import { useState, useEffect } from 'react';
import Table from '../components/Jobs/Table';
import Content from '../components/Content';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import '../components/Jobs/Jobs.css';

import Skeleton from '../components/ui/Skeleton/Skeleton';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchJobs } from '../utils/api';
import { UserInfoType } from '../types/AppTypes';
import { RootState } from '../redux/store';
import { useSelector } from 'react-redux';

const Jobs = (): JSX.Element => {
  const { jobs, loading, message, error } = useAppSelector((state) => state.jobs);
  const [skeletonColumns] = useState(['S.N', 'Name', 'Rss Url', 'Customer', 'Schedule', '']);
  const [skeletonRows] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
  
  const userInfo = useSelector((state: RootState) => state.userInfo.userInfo) as UserInfoType;

  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchJobs(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const permissions = userInfo?.permissions;

  if (error) {
    return (
      <div className="error">
        <span>{message}</span>
      </div>
    );
  }

  return (
    <>
      {(permissions?.includes('jobs.create') || userInfo?.isAdmin) && (
        <Link to="/job/add">
          <button
            type="button"
            className="add-button shadow bg-green-500 hover:bg-green-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4"
          >
            Add
          </button>
        </Link>
      )}
      <Content loading={false}>
        {loading ? <Skeleton columns={skeletonColumns} rows={skeletonRows} /> : <Table jobs={jobs} />}
      </Content>
    </>
  );
};

export default Jobs;
